import Aos from "aos";
import React, { useEffect } from "react";
import { FaStar, FaRegStar } from "react-icons/fa";

const TestimonialCard = ({ name, rating, message }) => {
	useEffect(() => {
		Aos.init({ duration: 500 });
	}, []);

	return (
		<div
			data-aos="zoom-in" data-aos-offset="80"
			className="relative bg-gradient-to-br from-[#0a0a0a] to-[#111] text-white rounded-2xl lg:p-6 p-4 pb-6 shadow-lg lg:w-[calc(100%/3-18px)] flex-shrink-0
    transition-transform duration-300 border border-[#00fffc] overflow-hidden lg:my-4 my-1"
		>

			{/* Glowing Border Animation */}
			<div className="absolute inset-0 rounded-2xl border-2 border-transparent" />

			{/* Name */}
			<h3 className="lg:text-lg text-base font-bold text-[#00fffc] tracking-wide">
				{name.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}
			</h3>

			{/* Star Rating */}
			<div className="flex my-3 gap-1 lg:text-sm text-xs">
				{Array.from({ length: 5 }).map((_, index) =>
					index < rating ? (
						<FaStar key={index} className="text-[#ffe600] drop-shadow-lg" />
					) : (
						<FaRegStar key={index} className="text-gray-600" />
					)
				)}
			</div>

			{/* Message */}
			<p className="text-gray-300 text-sm truncate-text">
				{message}
			</p>

			{/* Decorative Glow */}
			<div className="absolute top-[-50px] left-[-50px] w-40 h-40 bg-[#00fffc] opacity-20 rounded-full blur-3xl" />
			<div className="absolute bottom-[-50px] right-[-50px] w-44 h-44 bg-[#00ffb7] opacity-20 rounded-full blur-3xl" />

		</div>
	);
};

export default TestimonialCard;
